import { render, staticRenderFns } from "./OverlayProduct.vue?vue&type=template&id=6d4dd458&"
import script from "./OverlayProduct.vue?vue&type=script&lang=js&"
export * from "./OverlayProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d4dd458')) {
      api.createRecord('6d4dd458', component.options)
    } else {
      api.reload('6d4dd458', component.options)
    }
    module.hot.accept("./OverlayProduct.vue?vue&type=template&id=6d4dd458&", function () {
      api.rerender('6d4dd458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/pages/OverlayProduct.vue"
export default component.exports